import React, { useContext, useEffect, useMemo , useState } from "react";
import { Col, Dropdown, Icon, Menu, Modal, Row, Spin, Button, Select } from "antd";
import { DownloadIcon, EditPennIcon, HazmatIcon, HighPriorityIcon, PDFIcon, PrintIcon, RateConfirmIcon, StarIcon, TickIcon, TrashIcon, ViewMoreIcon, WarehouseIcon, PdfIconContextMenu, CloneOrderContextMenuIcon, SendEmailIcon, RemittanceIcon, ClockTimeIcon } from "../../common/CustomIcon";
import CloneOrders from "../../components/orders/CloneOrders";
import PrintLabels from "../../components/orders/PrintLabels";
import I18n from "../../common/I18n";
import { renderAlertMessage } from "../../helpers/common";
import { deleteOrder, fetchRateConfirmation, sendEmailOrderDetails, updateOrderDetails_v2, cloneOrders, sendArrivalNoticeEmail, downloadArrivalNoticePdf, downloadArrivalNoticeXlsx } from "../../api/OrdersApi";
import { base64ToBlob, handleDownload } from "../../common/preview";
import PdfPreviewViewer from "../../common/PdfPreviewViewer";
import { alertMessage, isEmpty } from "../../common/Common";
import { renderNotification } from "../../components/orders/OrderTypeIcons";
import { WarehouseContext } from "../../context/WarehouseContext";
import PODEmailsModal from "../../components/Tasks/PODEmailsModal";
import { UserContext } from "../../context/UserContext";
import PODEmailDrawer from "./PODEmailDrawer";
import WarningModal from "../../components/orders/WarningModal";
import ImportOrderModal from "./ImportOrderModal";
import userStore from "../../stores/UserStore";
import { fetchShortFormAccounts } from "../../api/Account";


const ContextMenu = (props) => {
    const  { nonPendingOrders, orderResponse, onPrintClick, onPrintOnHandReceipt, showCloneButton = false, 
        currentOrg, refreshDetails = () => { }, updateView = () => { }, setIsOrderDownloadModalOpen = () => { }, isShipper, orgRules } = props;
    const [visible, setVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [locked, setLocked] = useState(false); 
    const [toggleOptions, setToggleOptions] = useState(_.pick(orderResponse, ['wh_storage', 'is_hazardous', 'special', 'priority']) || {});
    const [trashHover, setTrashHover] = useState(false)
    const warehouseFilter = useContext(WarehouseContext);
    const { currentRole } = useContext(UserContext);
    const [showEmailModal, setShowEmailModal] = useState(false);
    const [isEmailLoading, setIsEmailLoading] = useState(false);
    const [isCloneClicked, setIsCloneClicked] = useState(false);
    const [warningMessage, setWarningMessage] = useState("")
    const [showWarningModal, setShowWarningModal] = useState(false);
    const [showImportModal, setShowImportModal] = useState(false);
    const [clonedImportData, setClonedImportData] = useState(null);
    const [accounts, setAccounts] = useState([]);
    const [accountsProgress, setAccountsProgress] = useState(false);
    const [showAccountModal, setShowAccountModal] = useState(false);
    const [selectedAccountId, setSelectedAccountId] = useState(undefined);
    const [isImportOrderCreated, setIsImportOrderCreated] = useState(false);
    const [showArrivalNoticeModal, setShowArrivalNoticeModal] = useState(false);
    const [isArrivalNoticeLoading, setIsArrivalNoticeLoading] = useState(false);
    const [isArrivalNoticeDownloadLoading, setIsArrivalNoticeDownloadLoading] = useState(false);
    const [isArrivalNoticeXlsxDownloadLoading, setIsArrivalNoticeXlsxDownloadLoading] = useState(false);
    const [isArrivalNoticePreviewLoading, setIsArrivalNoticePreviewLoading] = useState(false);
    const [arrivalNoticePreview, setArrivalNoticePreview] = useState({ blobUrl: null, fileName: null });

    useEffect(() => {
        const orgId = currentOrg?.id || userStore.getStateValue('selectedOrg');
        if (orgId) {
            setAccountsProgress(true);
            fetchShortFormAccounts(orgId).then((result) => {
                if (result.success) {
                    setAccounts(result.accounts || []);
                }
                setAccountsProgress(false);
            }).catch(() => {
                setAccountsProgress(false);
            });
        }
    }, [currentOrg]);


    const showOnHandReciptMenu = useMemo(() => {
        const warehouses=_.get(orgRules?.org_billing_rules, "on_hand_warehouse", [])
        const warehouseList = !_.isArray(warehouses) ? warehouses?.split(",") : warehouses;
        return (
            _.get(orgRules?.org_billing_rules, "require_on_hand_receipt") === "true" &&
                (_.includes(warehouseList, orderResponse?.customer_order_details?.warehouse_code)
                ||
                _.includes(warehouseList, "ALL"))
        );
    }, [orgRules]);

    const isSplitOrderConfigEnabled = useMemo(() => {
      return _.get(orgRules?.org_billing_rules, "enable_split_order") === "true";
    }, [orgRules]);

    useEffect(() => {
        if (isShipper || orderResponse?.customer_order_details?.is_locked !== undefined) {
            setLocked(isShipper || orderResponse.customer_order_details.is_locked === "true"  || orderResponse?.is_deleted_order  ? true : false);
        }
        setIsImportOrderCreated(false);
    }, [orderResponse]);

    const handleIconClick = () => {
        setVisible((prevVisible) => !prevVisible);
    };

    const handleVisibleChange = (flag) => {
        setVisible(flag);
    };

    const handleTenderRateConfirmation = () => {
      const order_id = orderResponse.id;
      setIsLoading(true);
      fetchRateConfirmation(order_id).then((result) => {
        if (result.success) {
          alertMessage(result.data.message, "success", 5);
          handleVisibleChange();
          refreshDetails();
          setIsLoading(false);
        } else {
          renderAlertMessage(result?.errors);
          handleVisibleChange();
          setIsLoading(false);
        }
      });
    };

    useEffect(() => {
        const details = _.get(orderResponse, "customer_order_details", {}) || {}
        setToggleOptions(_.pick(details, ['wh_storage', 'is_hazardous', 'special', 'priority']) || {})
    }, [orderResponse])

    const updateToggleOption = (element, value) => {
       const details = _.get(orderResponse, "customer_order_details" , false)
        const data = {
            [element]: value,
            customer_order_params: {
                customer_order_id: details.id,
                warehouse_id: details.warehouse_id,
                organization_id: currentOrg?.id || '',
                location_id:  ''
            },
        }
        
        updateOrderDetails_v2(orderResponse.id, data).then((result) => {
            if (result.success) {
              renderNotification(
                `Order ${orderResponse?.customer_order_details?.customer_order_number || ''} details has been updated`,
                "success"
              );
              setToggleOptions({
                ...toggleOptions,
                [element]: value,
              })
              setIsLoading(false);
              refreshDetails()

            } else {
              setIsLoading(false);
            }
          });
    }

    

    const handleDeleteOrder = (skipTenderorderDelete = false) => {
        setIsLoading(true)
        const delete_tender_order = orderResponse?.customer_order_details?.has_tender_order 
        const delete_order = !isEmpty(warningMessage) && skipTenderorderDelete ? true : false; // adding key to delete while after see warning for tender order and we want to skip deleting tender order by clicking No Button
        deleteOrder(orderResponse.id, delete_tender_order, delete_order).then((result) => {
          if (result.success) {
            const warning = result?.warning ? result.warning : "";
            const message = result?.message ? result?.message : I18n.t("messages.deleted");   
            if (isEmpty(warning)) {
              alertMessage(message);
              setIsLoading(false);
              setWarningMessage("")
              
              // Check if we came from linehaul and navigate accordingly
              const linehaulContext = sessionStorage.getItem('linehaulBackContext');
              if (linehaulContext) {
                const context = JSON.parse(linehaulContext);
                
                // Store pending message for linehaul to open route drawer if routeId exists
                if (context.routeId) {
                  sessionStorage.setItem('linehaulPendingMessage', JSON.stringify({
                    type: 'OPEN_ROUTE_DRAWER',
                    data: {
                      routeId: context.routeId,
                      routeType: context.routeType
                    }
                  }));
                }
                
                sessionStorage.removeItem('linehaulBackContext');
                sessionStorage.removeItem('justCameFromLinehaul');
                props.history.push('/line-haul');
              } else {
                props.history.push('/orders');
              }
            } else {
              // Show warning modal
              setIsLoading(false);
              setWarningMessage(warning);
            }    
          } else {
            setIsLoading(false)
            renderAlertMessage(result.errors)
          }
        });
    };

    // New warning modal component
    const confirmWarningDeletion = () => {
        return (
          <WarningModal
            warningMsg={`${orderResponse?.customer_order_number} related Agent orders will also be deleted. Do you want to proceed?`}
            onCancel={ () => setShowWarningModal(false) }
            onConfirm={() => {
              handleDeleteOrder();
            }}
            isLoading={isLoading}
            onCancelModal={()=>{
                setShowWarningModal(false);
            }}
          />
        );
        // return (
        // <Modal
        //     title={null}
        //     visible={showWarningModal}
        //     footer={null}
        //     closable={false}
        //     maskClosable={false}
        //     className="orderAlert warningModal"
        //     width={480}
        //     centered
        // >
        //     <div className="warning-content">
        //     {/* Warning Icon */}
        //     <div className="warning-icon">
        //         <Icon
        //         type="exclamation-circle" 
        //         theme="twoTone" 
        //         twoToneColor="#faad14"
        //         />
        //     </div>
            
        //     {/* Title */}
        //     <h3 className="warning-title">
        //         Warning
        //     </h3>
            
        //     {/* Warning Message */}
        //     <div className="warning-message">
        //         {warningMessage}
        //     </div>
            
        //     {/* Action Buttons */}
        //     <div className="warning-buttons">
        //         <Button
        //         size="large"
        //         key="no"
        //         className="btn-cancel"
        //         onClick={() => {
        //             handleDeleteOrder(false);
        //             setShowWarningModal(false)
        //             props.history.push("/orders");
        //         }}
        //         >
        //         No
        //         </Button>
        //         <Button
        //         type="primary"
        //         size="large"
        //         key="yes"
        //         className="btn-confirm"
        //         onClick={() => {
        //             handleDeleteOrder(true);
        //             setShowWarningModal(false)
        //             props.history.push("/orders");
        //         }}
        //         >
        //         Yes
        //         </Button>
        //     </div>
        //     </div>
        // </Modal>
        // );
    }

    const shouldShowEditOptions = !["SDR", "MDR", "SDD", "MDD"].includes(
        orderResponse?.customer_order_details?.order_label
      );

    const handleCreateImportOrder = () => {
        setIsLoading(true);
        cloneOrders({
            order_ids: [orderResponse.id],
            appointment_type: "EXISTING",
            is_import: true
        }).then((result) => {
            setIsLoading(false);
            if (result.success) {
                const clonedOrder = result.orders?.[0] || result.order_details?.[0] || result.data?.order_details?.[0];
                if (clonedOrder) {
                    setVisible(false);
                    setClonedImportData(clonedOrder);
                    setShowImportModal(true);
                    setIsImportOrderCreated(true);
                } else {
                    renderAlertMessage(["Failed to retrieve cloned order details"]);
                }
            } else {
                renderAlertMessage(result.errors);
            }
        }).catch((err) => {
            setIsLoading(false);
            console.error("Create Import Order error:", err);
        });
    };

    const handleCreateTag = (accountId) => {
        setIsLoading(true);
        cloneOrders({
            order_ids: [orderResponse.id],
            appointment_type: "EXISTING",
            is_import: true,
            account_id: accountId
        }).then((result) => {
            setIsLoading(false);
            if (result.success) {
                const clonedOrder = result.orders?.[0] || result.order_details?.[0] || result.data?.order_details?.[0];
                const newId = clonedOrder?.cloned_order_id;
                if (newId) {
                    setShowAccountModal(false);
                    setSelectedAccountId(undefined);
                    setVisible(false);
                    // Redirect to edit order screen for the new tag
                    if (props.history) {
                        props.history.push(`/orders/${newId}/details`);
                    }
                }
            } else {
                renderAlertMessage(result.errors);
            }
        }).catch((err) => {
            setIsLoading(false);
            console.error("Create Tag error:", err);
        });
    };

    const handleCreateTagClick = () => {
        setVisible(false);
        setShowAccountModal(true);
    };

    const onSendToEmail = async (data) => {
        setIsEmailLoading(true);
        const orderDetails = _.get(orderResponse, 'customer_order_details');
        const payload = {
            "customer_order_id": orderDetails?.id,
            "current_role": currentRole,
            "org_id": currentOrg?.id,
            "warehouse_ids": orderDetails?.warehouse_id,
            "email_ids": data.emails,
            "description": data.description,
            "attachment_type": data.file_attachment
        }
        sendEmailOrderDetails(payload).then((result) => {
            if (result.success) {
                renderNotification(result.data?.message, 'success');
                setIsEmailLoading(false);
                setShowEmailModal(false);
            } else {
                setIsEmailLoading(false)
                renderAlertMessage(result.errors)
            }
        })
    }

    const renderPODEmailsModal = () => {
        return (
            <PODEmailDrawer
                description={'Please find the attached PDF.'}
                title={"Send Order Details to Email"}
                accountId={orderResponse?.account?.account_id}
                isPODemailDrawerOpen={showEmailModal}
                setIsPODemailDrawerOpen={setShowEmailModal}
                onSendToEmail={onSendToEmail}
                isEmailLoading={isEmailLoading}
                isClosable={true}
                showOnHandReciptMenu={showOnHandReciptMenu}
            />
        );
    };

    const onSendArrivalNotice = async (data) => {
        setIsArrivalNoticeLoading(true);
        const orderDetails = _.get(orderResponse, 'customer_order_details');
        const payload = {
            "customer_order_id": orderDetails?.id,
            "description": "Please find the attached PDF.",
            "org_id": currentOrg?.id || orderDetails?.organization_id,
            "warehouse_ids": orderDetails?.warehouse_id,
            "special_instruction": data.special_instruction,
            "email_ids": data.emails
        }
        sendArrivalNoticeEmail(payload).then((result) => {
            if (result.success) {
                renderNotification(result.data?.message || "Arrival Notice sent successfully", 'success');
                setIsArrivalNoticeLoading(false);
                setShowArrivalNoticeModal(false);
            } else {
                setIsArrivalNoticeLoading(false);
                renderAlertMessage(result.errors);
            }
        }).catch((err) => {
            setIsArrivalNoticeLoading(false);
            renderAlertMessage([err?.message || "An error occurred"]);
        })
    }

    const buildArrivalNoticePayload = (data) => {
        const orderDetails = _.get(orderResponse, 'customer_order_details');
        return {
            customer_order_id: orderDetails?.id,
            org_id: currentOrg?.id || orderDetails?.organization_id,
            special_instruction: data?.special_instruction,
            orderDetails,
        };
    };

    const onDownloadArrivalNotice = async (data) => {
        setIsArrivalNoticeDownloadLoading(true);
        const { orderDetails, ...payload } = buildArrivalNoticePayload(data);
        downloadArrivalNoticePdf(payload).then((result) => {
            if (result.success && result.order_pdf) {
                const blob = base64ToBlob(result.order_pdf, 'application/pdf');
                const blobUrl = URL.createObjectURL(blob);
                const filename = result.filename || `Arrival notice for ${orderDetails?.customer_order_number || 'order'}.pdf`;
                handleDownload(blobUrl, filename);
                URL.revokeObjectURL(blobUrl);
                renderNotification("Arrival Notice downloaded successfully", 'success');
            } else {
                renderAlertMessage(result.errors || ["Failed to download Arrival Notice"]);
            }
        }).catch((err) => {
            renderAlertMessage([err?.message || "An error occurred"]);
        }).finally(() => {
            setIsArrivalNoticeDownloadLoading(false);
        });
    }

    const onDownloadArrivalNoticeXlsx = async (data) => {
        setIsArrivalNoticeXlsxDownloadLoading(true);
        const { orderDetails, ...payload } = buildArrivalNoticePayload(data);
        downloadArrivalNoticeXlsx(payload).then((result) => {
            if (result.success && result.order_xlsx) {
                const blob = base64ToBlob(
                    result.order_xlsx,
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                );
                const blobUrl = URL.createObjectURL(blob);
                const filename = result.filename || `Arrival notice for ${orderDetails?.customer_order_number || 'order'}.xlsx`;
                handleDownload(blobUrl, filename);
                URL.revokeObjectURL(blobUrl);
                renderNotification("Arrival Notice Excel downloaded successfully", 'success');
            } else {
                renderAlertMessage(result.errors || ["Failed to download Arrival Notice Excel"]);
            }
        }).catch((err) => {
            renderAlertMessage([err?.message || "An error occurred"]);
        }).finally(() => {
            setIsArrivalNoticeXlsxDownloadLoading(false);
        });
    }

    const onPreviewArrivalNotice = async (data) => {
        setIsArrivalNoticePreviewLoading(true);
        const { orderDetails, ...payload } = buildArrivalNoticePayload(data);
        downloadArrivalNoticePdf(payload).then((result) => {
            if (result.success && result.order_pdf) {
                if (arrivalNoticePreview.blobUrl) {
                    URL.revokeObjectURL(arrivalNoticePreview.blobUrl);
                }
                const blob = base64ToBlob(result.order_pdf, 'application/pdf');
                const blobUrl = URL.createObjectURL(blob);
                const filename = result.filename || `Arrival notice for ${orderDetails?.customer_order_number || 'order'}.pdf`;
                setArrivalNoticePreview({ blobUrl, fileName: filename });
            } else {
                renderAlertMessage(result.errors || ["Failed to preview Arrival Notice"]);
            }
        }).catch((err) => {
            renderAlertMessage([err?.message || "An error occurred"]);
        }).finally(() => {
            setIsArrivalNoticePreviewLoading(false);
        });
    }

    const renderArrivalNoticeModal = () => {
        return (
            <PODEmailDrawer
                description={'Please find the attached PDF.'}
                title={"Arrival Notice"}
                accountId={orderResponse?.account?.account_id}
                isPODemailDrawerOpen={showArrivalNoticeModal}
                setIsPODemailDrawerOpen={setShowArrivalNoticeModal}
                onSendToEmail={onSendArrivalNotice}
                onDownloadArrivalNotice={onDownloadArrivalNotice}
                onDownloadArrivalNoticeXlsx={onDownloadArrivalNoticeXlsx}
                onPreviewArrivalNotice={onPreviewArrivalNotice}
                isEmailLoading={isArrivalNoticeLoading}
                isDownloadLoading={isArrivalNoticeDownloadLoading}
                isXlsxDownloadLoading={isArrivalNoticeXlsxDownloadLoading}
                isPreviewLoading={isArrivalNoticePreviewLoading}
                isClosable={true}
                showOnHandReciptMenu={showOnHandReciptMenu}
                isArrivalNotice={true}
            />
        );
    };

    const renderAccountModal = () => {
        return (
            <Modal
                title="Select Account"
                visible={showAccountModal}
                onCancel={() => {
                    setShowAccountModal(false);
                    setSelectedAccountId(undefined);
                }}
                footer={[
                    <Button key="cancel" onClick={() => {
                        setShowAccountModal(false);
                        setSelectedAccountId(undefined);
                    }}>
                        Cancel
                    </Button>,
                    <Button
                        key="submit"
                        type="primary"
                        disabled={!selectedAccountId}
                        onClick={() => {
                            handleCreateTag(selectedAccountId);
                        }}
                        loading={isLoading}
                    >
                        Proceed
                    </Button>
                ]}
            >
                <div style={{ marginBottom: "10px" }}>
                    Please select an account to proceed with creating a tag Order:
                </div>
                <Select
                    showSearch
                    style={{ width: "100%" }}
                    placeholder="-- Select Account --"
                    loading={accountsProgress}
                    value={selectedAccountId}
                    onChange={(value) => setSelectedAccountId(value)}
                    filterOption={(input, option) =>
                        option.props.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                    }
                >
                    {accounts.map((account) => (
                        <Select.Option key={account.id} value={account.id}>
                            {`${account.name} (${account.code})`}
                        </Select.Option>
                    ))}
                </Select>
            </Modal>
        );
    };

    const details = orderResponse?.customer_order_details || {};
    const hasFreightArrivalDate = !!(details.freight_arrival_date || orderResponse?.freight_arrival_date);
    const inboundOrderNumbers = details?.inbound_order_numbers;
    const importOrderNo = inboundOrderNumbers?.import_order_number;
    const isOriginalBonded = (details.is_inbound === true || details.is_inbound === "true") && !(details.is_imported === true || details.is_imported === "true") && !importOrderNo && !isImportOrderCreated;
    const isImported = details.is_imported === true || details.is_imported === "true";
    const isCustomsCleared = details.is_customs_cleared === true || details.is_customs_cleared === "true";
    const orderId = details?.id || details?._id || orderResponse?.id;
    const isReadyForCustomer = !!details.ready_for_customer || (orderId && localStorage.getItem('ready_for_customer_' + orderId) === 'true');
    const showCreateTag = isImported && isCustomsCleared && !isReadyForCustomer && !details?.tag_3_order_number && details?.status === "COMPLETED";

    const menu = (
        <Menu>
          {/*  <Menu.Item key="0" className="toggle">TOGGLE</Menu.Item>
            <Menu.Item key="1" onClick={() => updateToggleOption('is_hazardous', !toggleOptions.is_hazardous)}>
                <Row type="flex" gutter={12} align="middle" className="row">
                    <Col><HazmatIcon /></Col>
                    <Col className="context-menu-text">Hazmat</Col>
                    <Col className="tick-icon">{toggleOptions.is_hazardous && <TickIcon />}</Col>
                </Row>
            </Menu.Item>
            <Menu.Item key="2" onClick={() => updateToggleOption('special', !toggleOptions.special)}>
                <Row type="flex" gutter={12} align="middle" className="row">
                    <Col><StarIcon /></Col>
                    <Col className="context-menu-text">Special</Col>
                     <Col className="tick-icon">{toggleOptions.special &&<TickIcon />}</Col>
                </Row>
            </Menu.Item>
            <Menu.Item key="3" onClick={() => updateToggleOption('priority', !toggleOptions.priority)}>
                <Row type="flex" gutter={12} align="middle" className="row">
                    <Col><HighPriorityIcon color="#000000" /></Col>
                    <Col className="context-menu-text">Priority</Col>
                     <Col className="tick-icon">{toggleOptions.priority &&<TickIcon />}</Col>
                </Row>
            </Menu.Item>
            {!["D", "R"].includes(orderResponse.type_of_order) && (<Menu.Item key="4" onClick={() => updateToggleOption('wh_storage', !toggleOptions.wh_storage)}>
                <Row type="flex" gutter={12} align="middle" className="row">
                    <Col><WarehouseIcon width="26px" height="26px" /></Col>
                    <Col className="context-menu-text">Warehouse Storage</Col>
                    <Col className="tick-icon">{toggleOptions.wh_storage &&<TickIcon />}</Col>
                </Row>
            </Menu.Item>)} */}
            {/* <Menu.Divider style={{ color: '#D5DEE6' }} /> */}
            {/* { shouldShowEditOptions && */}
            {!locked && (
                <Menu.Item key="edit" onClick={() => updateView("full_edit")}>
                    <Row type="flex" gutter={12} align="middle">
                        <Col><EditPennIcon />{" "}</Col>
                        <Col className="context-menu-text">Edit Order</Col>
                    </Row>
                </Menu.Item>
            )}
            {
                <Menu.Item key="email" onClick={() => {
                    setShowEmailModal(true);
                    setVisible(false)
                    }}>
                    <Row type="flex" gutter={12} align="middle">
                        <Col><SendEmailIcon color="#33393D" width="24" />{"  "}</Col>
                        <Col className="context-menu-text">Email</Col>
                    </Row>
                </Menu.Item>
            }
            {hasFreightArrivalDate && isImported && (
                <Menu.Item key="arrival_notice" onClick={() => {
                    setShowArrivalNoticeModal(true);
                    setVisible(false)
                    }}>
                    <Row type="flex" gutter={12} align="middle">
                        <Col><ClockTimeIcon color="#33393D" width="24" />{"  "}</Col>
                        <Col className="context-menu-text">Arrival Notice</Col>
                    </Row>
                </Menu.Item>
            )}
            {/* } */}
            {/* Create Import Order (only shown for original bonded orders) */}
            {isOriginalBonded && (
                <Menu.Item key="create_import_order" onClick={handleCreateImportOrder}>
                    <Row type="flex" gutter={12} align="middle">
                        <Col><Icon type="crown" style={{ fontSize: "16px", color: "#33393D" }} /></Col>
                        <Col className="context-menu-text">Create Import Order</Col>
                    </Row>
                </Menu.Item>
            )}
            {orderResponse?.customer_order_details?.has_tender && orderResponse.customer_order_details.status === "ASSIGNED" && (
                <Menu.Item
                    key="rate_confirmation"
                    onClick={handleTenderRateConfirmation}
                >
                    <Row type="flex" gutter={12} align="middle">
                        <Col>
                            <RateConfirmIcon />{" "}
                        </Col>
                        <Col className="context-menu-text">Rate Confirmation</Col>
                    </Row>
                </Menu.Item>
            )}
           { !isShipper && showCloneButton && !orderResponse?.customer_order_details?.is_split_order && <Menu.Item key="5" onClick={() => setIsCloneClicked(true)}>
                <Row type="flex" gutter={12} align="middle" 
                       onClick={(e) => {
                       // e.stopPropagation(); 
                        setVisible(false); 
                    }}>
                    <Col><CloneOrderContextMenuIcon /> </Col>
                    <Col className="context-menu-text"> 
                      <CloneOrders
                        resetOrders={ () => { setVisible(false) } }
                        orders={ [ ...props.nonPendingOrders ] }
                        filter={ 'NEW' }
                        size="small"
                        handleEditOrder={ props.handleEditOrder }
                        handleOrderclonedStatus={ props.handleOrderclonedStatus }
                        warehouseFilter={warehouseFilter }
                        organizationSettings={ props.organizationSettings }
                        selectedOrders={props.selectedOrders || []}
                        fromContextMenu={true}
                        isCloneClicked={isCloneClicked}
                        setIsCloneClicked={setIsCloneClicked}
                      />
                    </Col>
                </Row>
            </Menu.Item>}
           { props.showPrintLables && <Menu.Item key="6">

                         <PrintLabels
                            className={ "buttonCoolBlue marginRight10" }
                            buttonType="primary"
                            size="small"
                            label={ I18n.t("order.print_labels") }
                            isDisabled={ false }
                            handleSuccess={ () => { setVisible(false) } }
                            orderIds={ nonPendingOrders }
                            buttonIcon={"printer"}
                            fromContextMenu={true}
                            handleIconClick={handleIconClick}
                        />
             
            </Menu.Item>}
            <Menu.Item key="7" onClick={() => {
                props.handleBarCodePrint()
                 setVisible(false)
            }
            }>
                <Row type="flex" gutter={12} align="middle">
                    <Col><PrintIcon /></Col>
                    <Col className="context-menu-text">Print Barcodes</Col>
                </Row>
            </Menu.Item>

 {(orderResponse?.customer_order_details?.insertion_type === "PDF" || orderResponse?.customer_order_details?.insertion_type === "EMAIL") && ( 
    <Menu.Item
        key="10"
        onClick={() => {
            props.handePDFDiagnostic(orderResponse?.customer_order_details?.customer_order_id);
            setVisible(false);
        }}
    >
        <Row type="flex" gutter={12} align="middle">
            <Col><PDFIcon /></Col>
            <Col className="context-menu-text">PDF Diagnostic</Col>
        </Row>
    </Menu.Item>
)} 

           
            <Menu.Item key="8" onClick={() => {
                onPrintClick ()
                setVisible(false) 
                setIsOrderDownloadModalOpen(true)
              }
            }>
                <Row type="flex" gutter={12} align="middle">
                    <Col><PdfIconContextMenu/></Col>
                    <Col className="context-menu-text">Print Order</Col>
                </Row>
            </Menu.Item>
            {/* Split Order Menu */}
            {isSplitOrderConfigEnabled && !orderResponse?.customer_order_details?.is_split_order && (
                <Menu.Item key="11" 
                    onClick={() => {
                        props.onOpenSplitOrder();
                        setVisible(false);
                    }}
                >
                <Row type="flex" gutter={12} align="middle">
                    <Col><Icon type="apartment" style={{fontSize: 22, color: "#1D2540"}}/></Col>
                    <Col className="context-menu-text">Split Order</Col>
                </Row>
            </Menu.Item>
            )}

            {showOnHandReciptMenu && <Menu.Item key="9" onClick={() => {
                onPrintOnHandReceipt()
                setVisible(false)
                setIsOrderDownloadModalOpen(true)
            }
            }>
                <Row type="flex" gutter={12} align="middle">
                    <Col><RemittanceIcon borderWidth = "15" strokeColor = "#000000" /></Col>
                    <Col className="context-menu-text">On Hand Receipt</Col>
                </Row>
            </Menu.Item>}
            {!locked && isEmpty(orderResponse?.customer_order_details?.invoice_number) && (
                <Menu.Item key="13" className="delete" onClick={() => {
                    if(orderResponse?.customer_order_details?.has_tender_order) {
                        setShowWarningModal(true);
                    }else {
                    setVisible(false)
                    Modal.confirm({
                        title: 'Delete Order',
                        icon: <TrashIcon styling={{ width: '22px', height: '22px' }} color={'#D23B71'} />,
                        content: 'Are you sure you want to delete this order?',
                        cancelText: "No",
                        okText: "Yes",
                        onOk: () => handleDeleteOrder(),
                        onCancel: () => { },
                    })}
                }}
                    onMouseOver={() => setTrashHover(true)} onMouseLeave={() => setTrashHover(false)}
                >
                <Row type="flex" gutter={12} align="middle">
                    <Col>
                        {trashHover ?
                            <TrashIcon styling={{ width: '22px', height: '22px' }} color={'#D23B71'} />
                            :
                            <TrashIcon styling={{ width: '22px', height: '22px' }} />
                        }
                    </Col>
                    <Col className="context-menu-text">Delete</Col>
                </Row>
            </Menu.Item>
            )}
        </Menu>
    )

    const isExpedite = _.get()

    return (
        <Spin spinning={isLoading}>
                <div data-testid="view-more-actions" onClick={handleIconClick} className="view-more-container-div view-more-icon">
                    <ViewMoreIcon color="#576EC1" style={{ cursor: 'pointer' }} />
                </div>
            <Dropdown
                placement="bottomRight"
                overlay={menu}
                overlayClassName="context-menu-dropdown"
                trigger={["click"]}
                visible={visible}
                onVisibleChange={handleVisibleChange}
            // style={{ width: "235px" }}
            >
                <a
                    className="ant-dropdown-link"
                    onClick={(e) => {
                        e.preventDefault();
                    }}
                />
            </Dropdown>
            {renderPODEmailsModal()}
            {renderArrivalNoticeModal()}
            {showWarningModal && confirmWarningDeletion()}
            {showAccountModal && renderAccountModal()}
            <ImportOrderModal
                visible={showImportModal}
                onCancel={() => {setShowImportModal(false), refreshDetails()}}
                data={clonedImportData}
                history={props.history}
            />
            <PdfPreviewViewer
                blobUrl={arrivalNoticePreview.blobUrl}
                fileName={arrivalNoticePreview.fileName}
                zIndex={1100}
            />
</Spin>
    )
}

export default ContextMenu